module.exports = __webpack_public_path__ + "img/IMG_2671_L_WoodMatted_MockedUp.9fcc7150.jpg";